import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=7b4695ec&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=7b4695ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4695ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4695ec')) {
      api.createRecord('7b4695ec', component.options)
    } else {
      api.reload('7b4695ec', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=7b4695ec&scoped=true&", function () {
      api.rerender('7b4695ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-278xmOuTKBlO8/JS/comp/CookieBox.vue"
export default component.exports